module.exports = __webpack_public_path__ + "static/milo-2cdf0beba5900840610ccda55a8dfa23.jpg";